// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "04a4f4dcee7410c4395da1e344a3be516e83e2a6/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};